import { useSelector } from 'react-redux'
import { contractsSelectors } from '@/entity/contracts'
import { SecurityModal } from './SecurityModal'

export const DeleteEtd = ({ onToggleAction, onSuccessAction }) => {
	const contract = useSelector(contractsSelectors.contract)
	const onCancel = () => onToggleAction('deleteEtd', false)
	return <SecurityModal onProcess={onSuccessAction} onCancel={onCancel} contract={contract} />
}
